import { render, staticRenderFns } from "./hot-match.vue?vue&type=template&id=34853026&"
import script from "./hot-match.vue?vue&type=script&lang=js&"
export * from "./hot-match.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports